/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const MusicNote72Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 72, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="MusicNote72Icon"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M51.1377 14.1285C53.0625 13.551 55 14.9929 55 17.0025V43.314H54.9805C54.9921 43.479 55 43.646 55 43.814C54.9998 47.6798 51.8658 50.814 48 50.814C44.1342 50.814 41.0002 47.6798 41 43.814C41 39.948 44.134 36.814 48 36.814C49.9589 36.814 51.7294 37.6187 53 38.9156V23.1578L30 30.0581V50.814L29.9912 51.1734C29.8039 54.8722 26.7453 57.814 23 57.814C19.1342 57.814 16.0002 54.6798 16 50.814C16 46.948 19.134 43.814 23 43.814C24.9589 43.814 26.7294 44.6187 28 45.9156V23.3023C28 21.9776 28.8689 20.809 30.1377 20.4283L51.1377 14.1285ZM23 45.814C20.2386 45.814 18 48.0526 18 50.814C18.0002 53.5752 20.2387 55.814 23 55.814C25.7613 55.814 27.9998 53.5752 28 50.814C28 48.0526 25.7614 45.814 23 45.814ZM48 38.814C45.2386 38.814 43 41.0526 43 43.814C43.0002 46.5752 45.2387 48.814 48 48.814C50.7613 48.814 52.9998 46.5752 53 43.814C53 41.0526 50.7614 38.814 48 38.814ZM53 17.0025C53 16.3327 52.3545 15.8521 51.7129 16.0445L30.7129 22.3443C30.29 22.4712 30 22.8607 30 23.3023V27.9693L53 21.0699V17.0025Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

MusicNote72Icon.tags = ['music', 'note', 'audio', 'sound', 'melody'];

MusicNote72Icon.category = '72x72 (File types)';

MusicNote72Icon.iconSize = 72;
